import { render, staticRenderFns } from "./PayCard.vue?vue&type=template&id=305c5b52&"
import script from "./PayCard.vue?vue&type=script&lang=js&"
export * from "./PayCard.vue?vue&type=script&lang=js&"
import style0 from "./PayCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports